export default "__VITE_ASSET__a66a2e90__"